import { Flex } from 'components/shared/flex'
import { usePostCustomerOrderApi, usePutCustomerOrderApi } from 'api/customer_order'
import { FileField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { CustomerOrder, CustomerOrderForm } from 'entities/customer_order'

export type FormViewProps = {
    form: Form<CustomerOrderForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <Flex></Flex>
        </>
    )
}

type NewCustomerOrderFormProps = {
    onComplete?: () => void
}

export const NewCustomerOrderForm = (props: NewCustomerOrderFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostCustomerOrderApi()
    const form = useForm<CustomerOrderForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>CustomerOrderの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditCustomerOrderFormProps = {
    CustomerOrder: CustomerOrder
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditCustomerOrderForm = (props: EditCustomerOrderFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutCustomerOrderApi()
    const form = useForm<CustomerOrderForm>(props.CustomerOrder)

    useEffectSkipFirst(() => {
        form.set(props.CustomerOrder)
    }, [props.CustomerOrder])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>CustomerOrderの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <FormView form={form} apiError={api.apiError} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export type CustomerOrderCsvUploadForm = {
    form: Form<CustomerOrderForm>
    onComplete?: () => void
    onClose?: () => void
    show?: boolean
}

export const CustomerOrderCsvUploadForm = (props: CustomerOrderCsvUploadForm) => {
    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Body>
                <div style={{ padding: '0 20px' }}>
                    <FileField required form={props.form} attr="file" label="購買データ" />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onComplete}>アップロード</Button>
            </Modal.Footer>
        </Modal>
    )
}
